const ROUTE_CONSTANTS = {
  HOME: '/',
  COLLABORATORS: '/collaborators',
  MANUAL_ANALISYS_AUDIT: '/manual-analisys-audit',
  STATISTICS: '/statistics',
  RESTRICTED_OPTIONS: '/restricted-options',
  USER_MANAGEMENT: '/users',
  FORGOT_PASSWORD: '/forgot-password',
  PASSWORD_CREATION: '/create-password',
  PASSWORD_REDEFINE: '/redefine-password',
  PASSWORD_RECOVER: '/password-recover',
  PASSWORD_SUCCESS: '/password-success',
  EMAIL_SENT: '/email-sent',
  LOGIN: '/login',
  FORBIDDEN: '/forbidden',
}


export {
  ROUTE_CONSTANTS,
}
